<template>
  <div v-loading='loading' class=''>

    <el-dialog class='gDia' :title="$t('app_srban')" v-model="reasonDia" size='small'>
      <p style='margin-top:-8px;'>{{$t(app_banandrs)}}</p>
      <el-input :placeholder="$t('app_banandrs')" type="textarea" v-model="content" style="width:100%;margin-top:16px;"></el-input>

      <div slot="footer" style='margin-top:-20px;' class="dialog-footer">
	    <el-button @click="dialogVisible = false">{{$t('app_cancel')}}</el-button>
	    <el-button  type="primary" @click="onSubmit('3')">{{$t('app_suresm')}}</el-button>
	  </div>
    </el-dialog>

    <el-row class='gPageBorder gTopMg gPdTB'>
        <el-col :span='12'>
          <el-form class='gShowLeftForm' label-position='left' label-width="30%">
            <el-form-item :label="$t('app_name') ">
              {{editInfo ? editInfo.firmwareName : ''}}
            </el-form-item>
          </el-form>
        </el-col>

        <el-col :span='12'>
          <el-form class='gShowRightForm' label-position='left' label-width="30%">
            <el-form-item :label="$t('lin_global.version') ">
              {{editInfo ? editInfo.version : ''}}
            </el-form-item>
          </el-form>
        </el-col>

        <el-col :span='12'>
          <el-form class='gShowLeftForm' label-position='left' label-width="30%">
            <el-form-item :label="$t('app_distributor') ">
              {{editInfo ? editInfo.mechanismName : ''}}
            </el-form-item>
          </el-form>
        </el-col>

        <el-col style='margin-left:24px;margin-bottom:12px;'>
          <el-button @click="onCancel">{{$t('lin_btn.cancel')}}</el-button>
          <el-button type='success' @click="onSubmit('2')">{{$t('app_psverify')}}</el-button>
          <el-button type='danger' @click="reasonDia = true">{{$t('app_ban')}}</el-button>
          <el-button style='margin-left:20px;' type="info" @click="pushTest">{{$t('lin_global.tsazcs')}}</el-button>
        </el-col>
    </el-row>

    <el-dialog class='gDia' style='' size='small' :title="$t('lin_global.zdtslb')" v-model="showTable">
      <el-row gutter="" style="">
        <el-col :span="6">
              <el-input
                :placeholder="$t('lin_global.label_no')"
              icon="search"
              v-model="input1"
              :on-icon-click="handleIconClick"
              @keyup.enter.native="focusEvent(handleIconClick)">
            </el-input>
            </el-col>
      </el-row>

      <el-table
        :data="arrdata"
        border
        style="width:100%"
        class='gTopMg'
        ref="arrdata">
        <el-table-column
          prop="terminalName"
          :label="$t('lin_global.label_name')"
          width="200">
        </el-table-column>
          <el-table-column
          prop="terminalNo"
          :label="$t('lin_global.label_no')"
          width="140">
          </el-table-column>
          <el-table-column
            :label="$t('lin_global.status')"
          width="80">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('lin_global.online')}}</el-tag>
                      <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('lin_global.offline')}}</el-tag>
                      <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('lin_global.new_add')}}</el-tag>
                      <el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
            </template>
          </el-table-column>

          <el-table-column
          prop="mechName"
          :label="$t('lin_global.label_areaid')">
          </el-table-column>
          <el-table-column width="80"
            :label="$t('lin_global.ope')">
          <template slot-scope="scope">
            <!-- <el-button @click.stop="give(scope.row.terminalNo)" type="text">{{$t('lin_btn.send')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('lin_btn.send')" placement="top">
              <el-button type='text' @click.stop="give(scope.row.terminalNo)"><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip>
          </template>
          </el-table-column>
        </el-table>
        <div class="gPgDiv">
        <el-pagination
          class='gPg'
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecords">
        </el-pagination>
      </div>
    </el-dialog>


    <!-- === -->

    <el-dialog class='gDia' v-loading='loading' :title="$t('app_pushInstallTest')" v-model="dialogVisible" size=''>
      <el-row><el-col :span='10'><div style='width:100%;background:none;text-align:left;'>
        <el-input
        :placeholder="$t('app_searchTerminal')"
        icon="search"
        @keyup.enter.native='srchDevice'
        style=''
        v-model="srchValue">
        </el-input>
      </div></el-col></el-row>


      <el-table
      :data="tableData"
      border
      class='gTopMg'
      tooltip-effect="dark"
      style="width: 100%">
        <el-table-column
          align='center'
          prop="terminalNo"
          :label="$t('app_terNo')"
          width="150">
        </el-table-column>
        <!-- <el-table-column
          align='center'
          prop="terminalName"
          :label="$t('app_terName')"
          width="130">
        </el-table-column> -->
        <el-table-column
          prop="terminal_status"
          align='center'
          :label="$t('app_status')"
          width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_online')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('app_offline')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align='center'
          prop="mechName"
          :label="$t('app_distributor')"
          width=''>
        </el-table-column>
        <el-table-column
          prop="operate"
          :label="$t('app_operate')"
          align='center'
          width='80'>
          <template slot-scope='scope'>
            <!-- <el-button  @click='pushInstall(scope.row)' type=text>{{$t('app_push')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button type='text'  @click='pushInstall(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style=''>

        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
        <!-- <el-pagination
          small
          layout="prev, pager, next"
          :total="total">
        </el-pagination> -->

      </div>
    </el-dialog>

    <!-- <el-row>
            <el-col :span="24">
              <el-form ref="addForm" id="addForm" :model="form" :rules="rules" label-width="12.5%" class="gForm">

                <el-form-item :label="$t('app_name')" prop="name">
                  <el-label>{{editInfo ? editInfo.firmwareName : ''}}</el-label>
                </el-form-item>

                <el-form-item :label="$t('terminal.appBind.label_version')" prop="version">
                  <el-label>{{editInfo ? editInfo.version : ''}}</el-label>
                </el-form-item>
       
                <el-form-item label="" prop="">
                  <el-button @click='pushTest' style=''>{{$t('app_pushInstallTest')}}</el-button>
                </el-form-item>


                <el-form-item :label="$t('app_vStatus')" prop="version">
                  <el-radio class="radio" v-model="radio" label="2">{{$t('app_pass')}}</el-radio>
                  <el-radio class="radio" v-model="radio" label="3">{{$t('app_ban')}}</el-radio>
                </el-form-item>

                <el-form-item v-show="radio === '3'" label="" prop="">
                  <el-input v-model='content' type=textarea :autosize="{ minRows: 2, maxRows: 10}"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="onSubmit" >{{$t('app_submit')}}</el-button>
                </el-form-item>

              </el-form>
            </el-col>
    </el-row> -->

  </div>

</template>

<script>
  export default{
    data(){
      return{
        srchValue: '',
        index: 1,
        tableData: [],
        dialogVisible: false,
        reasonDia: false,
        content: '',
        radio: '2',
        editInfo: '',
        mechs: [],
        loading: 0,
        fileList: [],
        form:{
          name:'',
          version:'',
          type:'',
          url:'',
          mechanism: ''
        },
        rules:{
          'name':[{
            required: true,
                  message: this.$t('lin_global.notBlankName')
          }],
          'version':[{
            required: true,
                  message: this.$t('lin_global.notBlankVer')
          }],
          'type':[{
            required: true,
                  message: this.$t('lin_global.qxzlx')
          }],
          'mechanism':[{
            required: true,
                  message: this.$t('app_selectChannel')
          }],
          'url':[{
            required: true,
                  message: this.$t('lin_global.qxzscwj')
          }]
        },
        areaList:[]
      }
    },
    mounted(){  alert('da')
      var obj = this.$getWObj().info
      console.log(obj)
      if (obj) {
        this.editInfo = obj
      }
      this.getDevices()
    },
    computed: {
    },
    methods:{
      srchDevice () {

        this.getDevices()
      },
      pageSelect (index) {
        this.index = index
        this.getDevices()
      },
      getDevices () {
        var vl = this.srchValue ? this.srchValue : ''
        var channel = this.channelId ? this.channelId : ''
        var status = this.status ? this.status : ''
        this.loading = 1
        this.$getDvDevices(this.index, this.$gRow, '', vl, '', '','', '','','', (res) => {
          console.log('dv', res)
          this.loading = 0
          if (res.data) {
            this.tableData = res.data
            this.total = res.total
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      pushInstall (row) {
        //console.log(row, this.editInfo)
        //return
        this.loading = 1
        this.$pushFirmware('', this.editInfo.id,'1', row.terminalNo, (res) => {
          this.loading = 0
          this.$message(res.message)
        }, () => {
          this.loading = 0
        })
      },
      pushTest () {
        this.dialogVisible = true
      },
      hBlur (name) {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
          } else {
            return false
          }
        })
      },
      onSubmit:function(vl){
        this.loading = 1
        // alert(this.content)
        this.$checkFirmware(this.editInfo.id, this.content, vl, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$message.success(res.message)
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
        })
      },
      onCancel:function(){
        this.$router.go(-1);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// checkDetail.vue?3fd120c2